/**
 * React Query key factory for the resume domain. Import these instead of
 * writing inline `["resume", id]` arrays so invalidation targets and cache
 * writes stay consistent across hooks and call sites.
 */
// Note: the list and detail keys are deliberately separate roots
// (`["resumes"]` vs `["resume", id]`), matching the literals already used
// across the app. There is intentionally no single `all` that covers both —
// invalidate `lists()` and/or `detail(id)` explicitly.
export const resumeKeys = {
	/** List of the current user's resumes (GET resume-ledger). */
	lists: () => ["resumes"] as const,
	/** A single resume ledger by its ledger `_id` (GET resume-ledger/:id). */
	detail: (id?: string | null) => ["resume", id] as const,
	/** All review requests (GET resume-reviews). */
	reviews: () => ["resumeReviews"] as const,
	/** Feedback detail for one review request (GET resume-reviews/:id). */
	feedback: (id?: string | null) => ["resumeFeedback", id] as const,
	/** A resume's generated PDF attachment (download API). */
	printout: (id?: string | null) => ["resumePrintout", id] as const,
};
